var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-flex-rfsc"},[_c('img',{staticClass:"md-icon",attrs:{"src":"https://hichar-file.oss-cn-shanghai.aliyuncs.com/app/wxapp/md-icon3.0.png","alt":""}}),_c('span',{staticClass:"mdNumber"},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }